import GraphicUtils from "../../../utils/graphic-utils.js";
import ReportUtils from "../../../utils/report-utils.js";

export function createHorizontalBarChart({data, reportInfo, labelKey, reportName = null, exportName = null, customLabel = ["Descrição", "Quantidade"]}) {
    const statusData = GraphicUtils.horizontalStackedBarChart(data, reportInfo.reportId, labelKey);

    if (!statusData) return;

  const tableRows = statusData.labels.map((label, i) => [
    label,
    statusData.values[i]
  ]);

  const sheetName = (exportName ? exportName : (reportName ?? reportInfo?.reportName ?? "Sheet1")).replace(/[:\\\/\?\*\[\]]/g, "_").trim();

  ReportUtils.createExportableTable(
    customLabel,
    tableRows,
    sheetName
  );
}
export function createBarChart({data, reportInfo = null, labelFieldName = null, rotated = false, limit = null, reportName = null, exportName = null, valueFieldName = "qty", customLabel = null}){
  if (!Array.isArray(data)) data = [];

  const sheetName = (exportName ? exportName : (reportName ?? reportInfo?.reportName ?? "Sheet1")).replace(/[:\\\/\?\*\[\]]/g, "_").trim();

  const allLabels = [];
  const allValues = [];

  for(const item of data){
    allLabels.push(item[labelFieldName])
    allValues.push(item[valueFieldName])
  }

  const chartLabels = limit ? allLabels.slice(0, limit) : allLabels;
  const chartValues = limit ? allValues.slice(0, limit) : allValues;

  GraphicUtils.barChart(reportInfo.reportId, chartValues, chartLabels, rotated);
  if(data.some((item) => Number(item[valueFieldName]) > 0)) ReportUtils.createExportableTable(allLabels, allValues, sheetName, null, customLabel);
}

export function exportHeatMap(data, sheetName, hourLabel = "hour"){
  const headers = ["#", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
  const rows = data.map(item => [
    item[hourLabel],
    item.segunda,
    item.terca,
    item.quarta,
    item.quinta,
    item.sexta,
    item.sabado,
    item.domingo
  ]);
  ReportUtils.createExportableTable(headers, rows, sheetName);
}

export function ageComparator(a,b){
  if(a === "Menor de 18") return -1;
  if(b === "Menor de 18") return 1
  if(a === "Não informado") return 1;
  if(b === "Não informado") return -1;
  return String(a).localeCompare(String(b));
}
